export default "__VITE_ASSET__P_zCzhLL__"